<template>
    <div>
        <div v-if="isLoading" class="intelligence-state">
            <common-logo-spinner :width="56"></common-logo-spinner>
            <span>{{ $t('pages.intelligence.overview.loading') }}</span>
        </div>

        <div v-else-if="hasError" class="intelligence-state intelligence-state--error">
            {{ $t('pages.intelligence.overview.error') }}
        </div>

        <template v-else-if="overview">
            <intelligence-kpi-cards :kpis="overview.kpis"></intelligence-kpi-cards>

            <div class="intelligence-charts">
                <intelligence-funnel-chart :funnel="overview.funnel"></intelligence-funnel-chart>
                <intelligence-constraint-chart :breakdown="overview.constraintBreakdown"></intelligence-constraint-chart>
            </div>
        </template>
    </div>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import IntelligenceKpiCards from 'components/page-elements/intelligence/IntelligenceKpiCards'
    import IntelligenceFunnelChart from 'components/page-elements/intelligence/IntelligenceFunnelChart'
    import IntelligenceConstraintChart from 'components/page-elements/intelligence/IntelligenceConstraintChart'
    import IntelligenceAPI from 'api/IntelligenceAPI'

    export default {
        mixins: [PageWithTitleMixin],

        components: {
            IntelligenceKpiCards,
            IntelligenceFunnelChart,
            IntelligenceConstraintChart,
        },

        props: {
            filters: { type: Object, default: null },
        },

        data() {
            return {
                isLoading: false,
                hasError: false,
                overview: null,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.intelligence.overview.title')
            },
        },

        methods: {
            loadOverview() {
                if (!this.filters || !this.filters.fromDate || !this.filters.toDate) return

                this.isLoading = true
                this.hasError = false

                IntelligenceAPI.getOverview(this.filters)
                    .then((response) => {
                        this.overview = response
                    })
                    .catch(() => {
                        this.hasError = true
                        this.overview = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
        },

        watch: {
            filters: {
                immediate: true,
                handler() {
                    this.loadOverview()
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-charts {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px;
    }

    .intelligence-state {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 32px;
        color: #6b7280;
        font-size: 14px;

        &--error {
            color: #b91c1c;
        }
    }

    @media (max-width: 1100px) {
        .intelligence-charts {
            grid-template-columns: 1fr;
        }
    }
</style>
